import { render, staticRenderFns } from "./GtsSlider.vue?vue&type=template&id=7e345a34&scoped=true"
import script from "./GtsSlider.vue?vue&type=script&lang=js"
export * from "./GtsSlider.vue?vue&type=script&lang=js"
import style0 from "./GtsSlider.vue?vue&type=style&index=0&id=7e345a34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e345a34",
  null
  
)

export default component.exports